import { Modal } from "@mui/material";
import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import Styles from "./CreateCharge.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import {
  createNewCharge,
  updateNewCharge,
} from "../../../../Services/Payments/PaymentApi";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";

const chargeType = [
  { id: 1, label: "Platform", value: "Platform" },
  { id: 2, label: "Trader", value: "Trader" },
  { id: 3, label: "STU", value: "State/STU" },
  { id: 4, label: "ISTS", value: "ISTS" },
];

const isEditMode = (editData) => Boolean(editData?.data);

const CreateCharge = ({ open, handleClose, handleUpdate, editData }) => {
  const editMode = isEditMode(editData);

  const [chargeName, setChargeName] = useState(
    editMode ? editData.data.name : "",
  );
  const [type, setType] = useState(
    editMode
      ? chargeType.find((ele) => ele.value === editData.data.type) ?? chargeType[0]
      : chargeType[0],
  );
  const [isEditable, setIsEditable] = useState(
    editMode ? editData.data.isEditable : true,
  );

  const buildPayload = () => ({
    name: chargeName,
    value: 0,
    frequency: "ONE_TIME",
    type: type?.value,
    chargeType: type?.value,
    isEditable,
    isUserCharge: true,
    platform: "OTC",
  });

  const handleSubmit = async () => {
    if (chargeName.trim() === "") {
      ErrorMessage("Charge name cannot be empty");
      return;
    }

    if (editMode) {
      const payload = { id: editData.data.id, ...buildPayload() };
      const res = await updateNewCharge(payload);
      if (res?.data?.code === 200) {
        handleUpdate();
        handleClose();
      } else {
        ErrorMessage("Failed to update charge");
      }
    } else {
      const res = await createNewCharge(buildPayload());
      if (res?.data?.code === 200) {
        handleUpdate();
        handleClose();
      } else {
        ErrorMessage("Failed to create charge");
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.chargesCreateContainer}`}>
        <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
          <div className={`headingText`}>
            {editMode ? "Edit" : "Create"} Charge
          </div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.modalCOntainer}>
          <TextInput
            heading={`Enter New Charge Name*`}
            value={chargeName}
            onChange={(value) => setChargeName(value)}
            example={"ABC Charge"}
            type={"text"}
            height="45"
          />
          <SelectInput
            onChange={(data) => setType(data)}
            list={chargeType}
            value={type}
            example={"Select Charge Type"}
            heading={"Charge Type"}
            height={"45px"}
          />
          <div className={Styles.chargeSelection}>
            <div className={Styles.chargeSelectionHeading}>
              Is Charge Editable by User?
            </div>
            <div className={Styles.editableSelection}>
              <div
                onClick={() => setIsEditable(false)}
                className={!isEditable ? Styles.isEditable : undefined}
              >
                No
              </div>
              <div
                onClick={() => setIsEditable(true)}
                className={isEditable ? Styles.isEditable : undefined}
              >
                Yes
              </div>
            </div>
          </div>
          <div
            onClick={handleSubmit}
            className={`activeButton ${Styles.buttonElem1}`}
          >
            {editMode ? "Update" : "Submit"}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateCharge;
